/* Core & libraries */
import * as React from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */
import DynamicImageLoader from "../../dynamicImageLoader";

/* Components */

/* Styles */
import styles from "./styles.js";

const ASTextLoadingSpinner = ({ loadingText }) => {
  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <div className={classes.spinner} id="textLoader">
      <DynamicImageLoader imageName={"loading-circle.svg"} />
      { loadingText && (
        <p className={classes.loadingText}>
          <FormattedMessage id="spinners.textLoadingSpinner" />
        </p>
      )}
    </div>
  );
};

export default ASTextLoadingSpinner;